module.exports = __webpack_public_path__ + "media/assets/uos-5bb6d450.png";